/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckDuplicateOrgItemcode
 */
export interface CheckDuplicateOrgItemcode {
    /**
     * 
     * @type {string}
     * @memberof CheckDuplicateOrgItemcode
     */
    orgItemCode?: string | null;
}

/**
 * Check if a given object implements the CheckDuplicateOrgItemcode interface.
 */
export function instanceOfCheckDuplicateOrgItemcode(value: object): value is CheckDuplicateOrgItemcode {
    return true;
}

export function CheckDuplicateOrgItemcodeFromJSON(json: any): CheckDuplicateOrgItemcode {
    return CheckDuplicateOrgItemcodeFromJSONTyped(json, false);
}

export function CheckDuplicateOrgItemcodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckDuplicateOrgItemcode {
    if (json == null) {
        return json;
    }
    return {
        
        'orgItemCode': json['org_item_code'] == null ? undefined : json['org_item_code'],
    };
}

export function CheckDuplicateOrgItemcodeToJSON(json: any): CheckDuplicateOrgItemcode {
    return CheckDuplicateOrgItemcodeToJSONTyped(json, false);
}

export function CheckDuplicateOrgItemcodeToJSONTyped(value?: CheckDuplicateOrgItemcode | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_item_code': value['orgItemCode'],
    };
}

